'use client';
import Link from '../ui/Link';
import { twMerge } from 'tailwind-merge';

interface HeaderMenuItemProps {
    href: string;
    text: string;
    variant?: 'dark' | 'light';
    className?: string;
}

const HeaderMenuItem = ({
    href,
    text,
    variant = 'dark',
    className = ''
}: HeaderMenuItemProps) => {
    const baseClasses = 'text-base sm:text-lg lg:text-xl font-medium leading-5 sm:leading-6 lg:leading-xl hover:opacity-80 transition-opacity duration-200'
    const variantClasses = variant === 'light' ? 'text-text-on-dark' : 'text-text-primary'

    return (
        <Link
            href={href}
            ariaLabel={text}
            className={twMerge(baseClasses, variantClasses, className)}
        >
            {text}
        </Link>
    )
}

export default HeaderMenuItem